/**
 * Created by Gustavo on 08/06/2016.
 */

import {Injectable}      from '@angular/core';
import {Observable}      from 'rxjs/Observable';
import {AuthHttpService} from './auth-http.service';
import {AppDataService} from "./app-data.service";
import {RequestOptions, Headers, ResponseContentType,Response, Http} from '@angular/http';
import * as firebase from 'firebase';
import { EventBean } from '../beansts/Event';
import {ItemBean} from "../beansts/item.bean";

declare var Swal : any;

export interface CompanyData {
  aboutDescription: string;
  aboutImg: string;
  // outros campos...
}
@Injectable()
export class CompanyService {
  private scripts: any = {};
  private styles: any = {};
  firestore: any;

    constructor(private _authHttp : AuthHttpService, private _appData : AppDataService,private _http : Http) {
      // Initialize Firebase
      var config = {
        apiKey: "AIzaSyBt_xy2toHw8Z31ItiZgPUnahcaHERfSr8",
        authDomain: "coolkids-669fa.firebaseapp.com",
        databaseURL: "https://coolkids-669fa.firebaseio.com",
        projectId: "coolkids-669fa",
        storageBucket: "coolkids-669fa.appspot.com",
        messagingSenderId: "159459566585"
      };
      try {
        firebase.initializeApp(config);
        firebase.firestore().settings({ experimentalForceLongPolling: true });

      }
      catch (err){
        console.log('erro no firebase')
        //already connected
      }
    }




    ///////////////////YOUTUBE LIVECHAT//////////////////////////
    public checkinSymplaUser(ticket){
      return this._authHttp.get('https://us-central1-coolkids-669fa.cloudfunctions.net/makeSymplaCheckin?token='+this._appData.room.symplaToken+'&eventId='+this._appData.room.symplaEvent+'&ticketId='+ticket+'&room='+this._appData.room.id+'&liveplanetEvent='+this._appData.event.id+'&key='+this._appData.room.key);
    }


    public getEventOnApp(){
      return firebase.firestore().collection('eventOnApp');
    }

    public getActivities(){
      return firebase.firestore().collection('eventActivities');
    }

    /////////////////////////////////////////////////////////////
    public openExternalLink(link,shoundShare){
      let mheight = window.screen.availHeight;
      let mwidth = window.screen.availWidth;
      let width=mwidth*60/100;
      let height=mheight*60/100;
      let top=mheight*0.1
      let left=mwidth*0.1
      if (link.indexOf('https://')<0){
        link='https://'+link;
      }
      if (link.indexOf('{uid}')){
        link = link.replace('{uid}',this._appData.instagramUser.uid);
      }
      if (this._appData.android){
        window.location.href=link;

/*        this.sendNotificationToSomeoneElse(
          this._appData.event,
          this._appData.instagramUser,
          this._appData.instagramUser,
          '',
          '',
          'openAppLink',
          link,
          true);*/
          Swal.fire({title:'Uso no celular',text:'Links externos estão configurados para funcionar apenas no PC. Se você quiser ter toda experiência de imersão e acesso aos links, sugerimos que você use a plataforma no computador.'})

        }
      else{
        window.open(link,
          'targetWindow',
          'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width='+width+',height='+height+',top='+top+',left='+left                    );
      }
/*      if (this._appData.localConference){
        if (shoundShare){
          Swal.fire({
            title: 'Compartilhar Link',
            text: 'Clique OK para compartilhar o link onde você está. Caso queira enviar um link alternativo (como uma sala de jogo) preencha com o link alternativo e clique ok. Cloque cancelar para fechar esse diálogo',
            input:'text',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'OK',
            showLoaderOnConfirm: true,
            preConfirm: (login) => {
            },
            allowOutsideClick: () => !Swal.isLoading()
          }).then ((result)=>{
            let lnk=link
            if (result.value){
              lnk=result.value;
            }
              this._appData.localConference.forEach(element => {
                if (element.uid!=this._appData.instagramUser.uid){
                  this.sendNotificationToSomeoneElse(this._appData.event,
                    this._appData.instagramUser,
                    element,
                    'Convite para o link',
                    this._appData.instagramUser.full_name+'lhe está convidando para o link onde ele está',
                    'seeLink',
                    lnk,
                    false)

                }
              });

          })

        }

      }*/
    }

    public getPayments(event){
      return firebase.firestore().collection('comandas').doc(event.id.toString()).collection('users')
    }
    public updatePayment(event,payment){
      let payload = {
        notification: {
          title: 'Comanda processada',
          body: 'Você já pode finalizar seu pagamento.',
      }}
      return firebase.firestore().collection('comandas').doc(event.id.toString()).collection('users').doc(payment.uid).set(payment)
    }

  public authenticateFb (muser) {
      if (!muser.id){
        return;
      }
      if (!muser.full_name){
        muser.full_name='Favor cadastrar seu nome'
      }
      if (!muser.email){
        muser.email=muser.id.toString()+'@coolkids.com.br'
      }
      //I have token i need the rest of the INSTAGRAM DATA
      //start searching for user on database...
      var db=firebase.firestore();
      return db.collection('users').where('fbId','==',muser.id).get();
  }
  public authenticateInstagram (id) {
    //I have token i need the rest of the INSTAGRAM DATA
    //start searching for user on database...
    var db=firebase.firestore();
    return db.collection('users').where('id','==',id).get();
}
  public updateFirebaseUserProfile(user){
    return firebase.firestore().collection('users').doc(user.uid).set(user);
  }
  public messageReadFromLocalPosition(room){
    return firebase.database().ref("talk/room/"+room);
  }

  public messageWriteToLocalPosition(room,msgObj){
    //mylocation
    //add to others based on direction
   

    firebase.database().ref("talk/room/"+room+"/").push(msgObj);

  }

//////////////////////USER CHAT
public getUserMessages(link){
  let ref='userChat/'+link;
  return firebase.database().ref(ref);
}
public addUserMessage(source,roomlink,newmessage){
  let ref=source+"/"+roomlink;
  return firebase.database().ref(ref).push(
    newmessage
  )
}
////////////////////USER CONTACTS
public insertContact(user,friend,updateXp){
  if (!friend.fcmToken) friend.fcmToken='';
  if (!friend.token) friend.toke='';
  if (!user.fcmToken) user.fcmToken='';
  if (!user.token) user.token='';

  if (!user.popularity) user.popularity=0;
  if (!friend.popularity) friend.popularity=0;
  if (!user.popularityLevel) user.popularityLevel=1;
  if (!friend.popularityLevel) friend.popularityLevel=1;

  //make sure friend is caps on name
  friend.full_name=friend.full_name.toUpperCase();

  firebase.firestore().collection('users').doc(friend.uid).get().then(val=>{
    let friendFullData=val.data();
    if (friendFullData){
      friendFullData.full_name=friendFullData.full_name.toUpperCase();
      firebase.firestore().collection('contactList').doc(user.uid).collection('contacts').doc(friend.uid).set(
        friendFullData
      ).then(val=>{
        console.log('success')
      })
      firebase.firestore().collection('contactList').doc(friend.uid).collection('contacts').doc(user.uid).set(
        user
      ).then(val=>{
        console.log('success')
      })
/*      if (updateXp){
        user.popularity=user.popularity+50;
        friendFullData.popularity=friendFullData.popularity+100;
        this._appData.instagramUser=user;

        firebase.firestore().collection('users').doc(user.uid).update({popularity:user.popularity}).then(val=>{
        });
        firebase.firestore().collection('users').doc(friendFullData.uid).update({popularity:friendFullData.popularity}).then(val=>{
        });
      }*/
    }

  })
}
public getUserFavoriteRooms(user){
  return firebase.firestore().collection('userRoomList').doc(user.uid).collection('rooms');
}
public getContacts(user){
  return firebase.firestore().collection('contactList').doc(user.uid).collection('contacts');
}


////////////////////USER CONTACTS
public followUser(user,friend){
  //make sure friend is caps on name

      firebase.firestore().collection('userFollows').doc(user.uid).collection('contacts').doc(friend.uid).set({uid:friend.uid,full_name:friend.full_name,profile_picture:friend.profile_picture}).then(val=>{
        console.log('success')
      })
      firebase.firestore().collection('userFollowing').doc(friend.uid).collection('contacts').doc(user.uid).set({uid:user.uid,full_name:user.full_name,profile_picture:user.profile_picture}).then(val=>{
        console.log('success')
      })
}
public getFollowing(user){
  return firebase.firestore().collection('userFollowing').doc(user.uid).collection('contacts')
}
public getFollows(user){
  return firebase.firestore().collection('userFollows').doc(user.uid).collection('contacts')
}


public checkContacts(user,friend){
  return firebase.firestore().collection('contactList').doc(user.uid).collection('contacts').doc(friend.uid);
}


//////////////////////////////// EVENT CHAT

public getRoomMessages(room,roomlink){
  let source="chatOnRoom"
  let ref=source+'/'+room;
  if (roomlink!=null){
    if (roomlink.length>0){
      ref=ref+'/'+roomlink;
    }
  }
  return firebase.database().ref(ref);
}

public addRoomMessage(room,roomlink,newmessage){
  let source="chatOnRoom"
  let ref=source+"/"+room;
    if (roomlink!=null){
      if (roomlink.length>0){
        ref=ref+'/'+roomlink;
      }
    }
  return firebase.database().ref(ref).push(
    newmessage
  )
}
////////////end messages


public getTriggerNotificationData(uid,rewardId){
  return firebase.firestore().collection("triggerRewards").doc(rewardId).collection('users').doc(uid)
}

  public addToLove(event,user){
    if (!user.neighbour) user.neighbour='';
    if (!user.birthdate) user.birthdate=0;
    if (!user.token) user.token='';
    if (!user.sex) user.sex='M';
    if (!user.bio) user.bio='';
    if (!user.vippoints) user.vippoints=0;
    if (!user.fcmToken) user.fcmToken='';
    if (!user.avatar) user.avatar="./assets/characters/m0.png"
    if (!user.profile_picture) user.profile_picture='';
    if (!user.username) user.username='';
    if (!user.full_name) user.full_name='';
    if (!user.vip) user.vip=false;
    if (!event.room) event.room="1"
    if (event.incognito){
      user.profile_picture='';
      user.username='';
      user.full_name='???';
    }
    return firebase.firestore().collection('loveOnEvent').doc(event.id.toString()).collection('users').doc(user.uid).set({
        uid: user.uid,
        full_name: user.full_name,
        profile_picture: user.profile_picture,
        fcmToken:user.fcmToken,
        vippoints:user.vippoints,
        active:true,
        bio:user.bio,
        sex:user.sex,
        token:user.token,
        avatar:user.avatar,
        socialname:user.username,
        birthdate:user.birthdate,
        vip:user.vip,
        room:event.room,
        neighbour:user.neighbour
      })
  }
  public updateUserOnParty(event,user){
    if (event.incognito){
      user.full_name='???';
      user.profile_picture='';
      user.username='';
    }
    return firebase.firestore().collection('loveOnEvent').doc(event.id.toString()).collection('users').doc(user.uid).set(user)
}
public updateUserProperty(property,value,user){
  let update={};
  update[property]=value;
  if (isNaN(user.uid)){
        return firebase.firestore().collection('users').doc(user.uid).update(update)
  }

}
public addToEvent(uid,eventToGo){
  var clientUser=this._appData.instagramUser;
  var avatar;
  var profile_picture;
  if (clientUser){
    avatar=clientUser.avatar;
    profile_picture=clientUser.profile_picture;
  }
  if (!avatar) avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh0.png?alt=media&token=06662e87-0614-40b5-a0d2-9f454977429d'
  if (!profile_picture) profile_picture="https://liveplanet.app.br/assets/landingstyle/profile.pngg"
  if (!eventToGo) return;
  let partyToGo=eventToGo.id.toString();
  //make sure he is on the right place
  if (!this._appData.instagramUser.event || this._appData.instagramUser.event.toString()!=partyToGo){
    this._appData.instagramUser.event=partyToGo;
    this._appData.instagramUser.room=eventToGo.room;
  }

  if (uid && uid!='1'){
    //busco o usuario
    firebase.firestore().collection('loveOnEvent').doc(partyToGo).collection('users').doc(uid).get().then(onsnap=>{
      let onEvent=onsnap.data();
      if (onEvent){
        //console.log('on event');
        //send directly to event but update profile picture and avatar
        let date=new Date();
        let time=date.getTime();
        firebase.firestore().collection('loveOnEvent').doc(partyToGo).collection('users').doc(uid).update({profile_picture:profile_picture,avatar:avatar});
          let domain=window.location.origin
        window.location.replace(domain+"/gameevent/"+partyToGo);
        return;
      }
      else{
        let user=this._appData.instagramUser
          if (!user) return;
          firebase.firestore().collection('loveOnEvent').doc(partyToGo).collection('users').doc(uid).set(user);
          let domain=window.location.origin
          window.location.replace(domain+"/gameevent/"+partyToGo);
       }
    });

  }
}
  public getLoveList(event){
      return firebase.firestore().collection('loveOnEvent').doc(event.id.toString()).collection('users');
  }
  public getLoveReference(event){
    try{
      return firebase.firestore().collection('loveOnEvent').doc(event.id.toString()).collection('users');
    }
    catch(err){
      return null;
    }
  }

  public getPartyMember(event,user){
    try{
      return firebase.firestore().collection('loveOnEvent').doc(event.id.toString()).collection('users').doc(user.uid);
    }
    catch(err){
      return null;
    }
  }


  public getCompanyWorkers(company){
    return firebase.firestore().collection('company-workers').doc(company.dbId).collection('workers')
  }
  public authenticateEmailPassword(email,password){
    return firebase.auth().signInWithEmailAndPassword(email,password);
  }
  public getUsersByName(name){
    return firebase.firestore().collection('users').where('full_name','>=',name).get();
  }
  public getUsersByEmail(name){
    return firebase.firestore().collection('users').where('email','==',name).get();
  }
  public getUsersByExternalCode(code){
    return firebase.firestore().collection('users').where('code','==',code).get();
  }

  public getUsersByTicket(event,ticket){
    return firebase.firestore().collection('loveOnEvent').doc(event).collection('users').where('externalTicket','==',ticket).get();
  }

  public getUsersByLogin(name){
    return firebase.firestore().collection('users').where('username','>=',name).get();
  }





  public addNewFileToDrive(uid,type,filename){
    return new Promise(function (resolve, reject) {
      var xmlhttp = new XMLHttpRequest();   // new HttpRequest instance
      var theUrl = 'https://us-central1-coolkids-669fa.cloudfunctions.net/addFilesOnFolder';
      xmlhttp.open("POST", theUrl);
      xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xmlhttp.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(xmlhttp.response);
        } else {
          reject({
            status: this.status,
            statusText: xmlhttp.statusText
          });
        }
      };
      xmlhttp.onerror = function () {
        reject({
          status: this.status,
          statusText: xmlhttp.statusText
        });
      };
      xmlhttp.send(JSON.stringify({ "user": uid, "type": type, "name":filename }));
    });




  }

  public checkCPF(cpf){
    let  db = firebase.firestore();
    return db.collection('users').where('cpf','==',cpf).get();
  }
  public registerUser(email,password){
    firebase.firestore().collection('mailMkt').doc(email).set({
      email:email,
      lastSend:0,
      name:'',
      sex:''
    });

    return firebase.auth().createUserWithEmailAndPassword(email,password)
  }

  public getDresser(id){
    let  db = firebase.firestore();
    return db.collection('dresses').doc(id).get();

  }
  public getUserByUid(uid){
    let  db = firebase.firestore();
    return db.collection('users').doc(uid).get();
  }
  public updateUserOnList(myuser,myevent,_promoter,_list){
    if (!myuser.cpf){
      myuser.cpf=''
    }
    if (!myuser.email){
      myuser.email=''
    }
    if (!myuser.phone){
      myuser.phone='';
    }
    if (!myuser.profile_picture){
      myuser.profile_picture='/assets/images/invited.png'
    }
    if (!myuser.fcmToken){
      myuser.fcmToken=''
    }
    let token=this._appData.token;
    if (!token) token='';
    var invisible=false;
    if (myuser.invisible){
      invisible=true;
    }
    let  db = firebase.firestore();
    let path=_promoter+'_'+_list;
    let mydata={
      cpf:myuser.cpf,
      email:myuser.email,
      full_name:myuser.full_name,
      list:_list,
      phone:myuser.phone,
      profile_picture:myuser.profile_picture,
      promoter:_promoter,
      uid: myuser.uid,
      checkin:0,
      checkout:0,
      paid:0,
      token:token,
      fcmToken:myuser.fcmToken,
    }
    let eventRef=db.collection('userOnEvent').doc(myevent.id.toString()).collection(path).doc(myuser.uid);
    const unsubscribe = eventRef.set(mydata)
    return unsubscribe;
  }
  public removeToList (myuser,myevent,_promoter,_list) {
      var db= firebase.firestore();
      var key=myevent.id.toString();
      var user=myuser;
      _promoter='torugo_0'
      var eventRef = db.collection('userOnEvent').doc(key).collection(_promoter).doc(user.uid).delete();
    }

  public gotoOutsideLink(event){
      let  db = firebase.firestore();
      let date=new Date();
      let milis=date.getTime().toString();
      let code='nocode'
      if (event.code){
        code=event.code;
      }
      if (this._appData.instagramUser){
        let eventRef=db.collection('outsideLinkClicks').doc(event.id.toString()).collection('clicks').doc(milis).set({
          date: milis,
          code:code,
          user:this._appData.instagramUser,
          click:true}).then((val)=>{console.log('outsidelink saved')});
      }
      else{
        let eventRef=db.collection('outsideLinkClicks').doc(event.id.toString()).collection('clicks').doc(milis).set({
          date: milis,
          code:code,
          user: {uid: 'nan', name:'não registrado'},
          click:true}).then((val)=>{console.log('outsidelink saved')});
      }

    }
    public forgetPassword(email){
      return firebase.auth().sendPasswordResetEmail(email)
    }
    public getEvents () : any {
      let date=new Date();
      let dayofWeek=0-date.getDay();//sets for monday of this week;
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setDate(date.getDate()+dayofWeek);
      let milis=date.getTime();

      //start searching for user on database...
      try{
        let  db = firebase.firestore();
        let eventRef=db.collection('events').where('dateStart','>',milis);
        const obs = new Observable((observer) => {
         const unsubscribe = eventRef.onSnapshot(snapshot => {
           let events=[];
           let eventswithBenefits=[];
           snapshot.forEach(doc => {
             if (doc.data().benefits){
               eventswithBenefits.push(doc.data());
             }
             else{
               events.push(doc.data());
             }
           });
           eventswithBenefits=eventswithBenefits.concat(events)
           this._appData.events=eventswithBenefits;
           observer.next(							eventswithBenefits        );
         });
         return { unsubscribe };
        });
        return obs;
      }
      catch (err){
        return null;
      }
    };
    public getEventRef (id) {
      return firebase.firestore().collection('events').doc(id);
    }
    public getEventById (id) {
      if (isNaN(Number(id))) {
        try{
          let  db = firebase.firestore();
          let eventRef=db.collection('events').where('code','==',id);
          const obs = new Observable((observer) => {
          const unsubscribe = eventRef.onSnapshot(snapshot => {
            snapshot.forEach(val=>{
              let ev=val.data();
              if (ev.code==id){
                observer.next(ev);
              }
            })
           });
           return { unsubscribe };
          });
          return obs;
        }
        catch (err){
          return null;
        }
      }else{
        try{
          let  db = firebase.firestore();
          let eventRef=db.collection('events').doc(id.toString());
          const obs = new Observable((observer) => {
           const unsubscribe = eventRef.onSnapshot(snapshot => {
             observer.next(snapshot.data());
           });
           return { unsubscribe };
          });
          return obs;
        }
        catch (err){
           return null;
        }

       }


    };

    public getConsumeDashboard(event){
      return firebase.firestore().collection('eventDashboard').doc(event.id.toString()).get();

    }

    public getCompanyById (id) {
            var db=firebase.firestore();
            //Recover all events bigger than monday of this week;
            return db.collection("companies").doc(id);
    };

    public updateGCMToken (mytoken) {
      if (this._appData.instagramUser){
        return this._authHttp.post('https://us-central1-coolkids-669fa.cloudfunctions.net/updateGCMToken',JSON.stringify({token:mytoken,user:this._appData.instagramUser}));
      }
      else{
        return this._authHttp.post('https://us-central1-coolkids-669fa.cloudfunctions.net/updateGCMToken',JSON.stringify({token:mytoken}));
      }

    };




    public getEventsRef () {
      var db=firebase.firestore();
      var eventRef = db.collection('events');
      return eventRef;
    };




    public getMyEvents (uid) {
      //start searching for user on database...
      var db=firebase.firestore();
      var eventRef = db.collection('events').where('promoter','==',uid.toString());
      return eventRef.get()
    };

    public getFBEventList (event,promoter,list) {
      return firebase.firestore().collection('userOnEvent').doc(event.id.toString()).collection(promoter+'_'+list).get();
  };

    public updateFirebaseEvent(myevent){
      if (!myevent.id){
        //novo evento crie um id pra ele
        let d=new Date();
        let mi=d.getTime();
        myevent.id=mi.toString();
      }
        return firebase.firestore().collection('events').doc(myevent.id.toString()).set(myevent);
    }
    public getCard (uid) {
      return firebase.firestore().collection('cards').doc(uid);
    };

    public updateProfile (profile)  {
                      if (profile.container){
                        profile.container=null;
                      }         
      return firebase.firestore().collection('users').doc(profile.uid).set(profile);
    }



    public updateEventFriends(event,promoter,listIndex,user,myfriends){
      return firebase.firestore().collection('userOnEvent').doc(event.id.toString()).collection(promoter+'_'+listIndex).doc(user.uid).update({friends: myfriends})
    }

    public getOutsideLinkClicks(eventId){
      return firebase.firestore().collection('outsideLinkClicks').doc(eventId.toString()).collection('clicks').get();
    }


    public newEventNotification(event){
      let title='Nova Live no LIVEPARTY!!';
      let message='Confira no LIVEPARTY o evento '+event.name;
      return this._authHttp.get('https://us-central1-coolkids-669fa.cloudfunctions.net/sendUsersNotification?title='+title+'&message='+message+'&kind=all');
    }
    public notifyUser(user,title,message){
      return this._authHttp.get('https://us-central1-coolkids-669fa.cloudfunctions.net/sendGCMNotification?title='+title+'&message='+message+'&token='+user.fcmToken);
    }

    public addVippoints(points,user){
      firebase.firestore().collection('users').doc(user.uid).get().then((val)=>{
        let us=val.data();
        let vippoints=us.vippoints;
        if (!vippoints) vippoints=0;
        vippoints=vippoints+parseInt(points);
        us.vippoints=vippoints;
        return firebase.firestore().collection('users').doc(user.uid).update({vippoints:vippoints});
      });
    }

    public getRoom(roomId){
      return firebase.firestore().collection('rooms').doc(roomId);
    }
    public getLocalRoom(roomId){
      return fetch(
          'http://127.0.0.1:8080/rooms/' + roomId + '/room.json'
      )
//      return this._authHttp.get('http://127.0.0.1:8080/rooms/'+roomId+'/room.json');
    }
    public getLocalCompany(dbId){
      return fetch(
          'http://127.0.0.1:8080/companies/' + dbId + '/company.json'
      )
//      return this._authHttp.get('http://127.0.0.1:8080/rooms/'+roomId+'/room.json');
    }

    public getSocial(social){
      return firebase.firestore().collection('social-rooms').doc(social.id);

    }

    public getEventNotificationFeed(event){
      return firebase.database().ref('event_notifications/'+event.id).limitToLast(1);
    }

    public addEventNotification(event,notification){
      return firebase.database().ref('event_notifications/'+event.id+'/'+notification.date).set(notification);
    }

    public getNotificationFeed(event,user){
      return firebase.database().ref('user_notifications/'+user.uid).limitToLast(1);
    }
    public getUserNotifications(user){
      return firebase.database().ref('user_notifications/'+user.uid);
    }

    public readNotification(event,user,notification){
      return firebase.database().ref('user_notifications/'+user.uid+'/'+notification.key).update({read:true});
    }

/////MEETING AUTHORIZATION
    public getRoomNotifications(room){
      return firebase.database().ref('room_notifications/'+room.id).limitToLast(1);
    }
    public addRoomNotification(room,notification){
      return firebase.database().ref('room_notifications/'+room.id).push(notification);
    }
    public readRoomNotification(room,notification){
      return firebase.database().ref('room_notifications/'+room.id+'/'+notification.key).update({read:true});
    }


///END OF MEETING AUTHORIZATION



    public getEmojis(event){
      return firebase.database().ref('event_emojis/'+event.id.toString());
    }
    public addEmojis(event,emoji){
      let date=new Date();
      let time=date.getTime();
      return firebase.database().ref('event_emojis/'+event.id.toString()).push({thumbnail:emoji,timestamp:time});
    }
    public sendNotificationToSomeoneElse(event,user,someoneelse,subject,message,kind,link,answer){
      let date=new Date();
      let time=date.getTime();
      let action='';
      if (kind=='blink'){
       if (!answer){
        action='Piscar de volta';
       }
       else{
         action='OK'
       }
      }
      else if (kind=='askContact'){
        if (!answer){
          action='Sim'
        }
         else{
           action='Adicionar'
         }

      }
      else if (kind=='callToGroup'){
        if (!answer){
          action='Aceito'
        }
        else{
           action='Ir para mesa'
         }
      }
      else if (kind == 'chat'){
          action = 'Ir para conversa';
      }
      else if (kind=='askToEnterTable'){
        if (!answer){
          action='Aceito ir pra mesa'
        }
        else{
           action='Ir para mesa'
         }
      }
      if (!event){
        event={id:'none'}
      }

      let token=''
      firebase.firestore().collection('users').doc(someoneelse.uid).get().then((val)=>{
        let somelse=val.data();
        if (somelse.token){
          token=somelse.token
          this._authHttp.get('https://us-central1-coolkids-669fa.cloudfunctions.net/sendGCMNotification?token='+token+'&title='+subject+'&message='+message).subscribe(val=>{
            console.log('sent')
          });
        }
        if (somelse.fcmToken){
          token=somelse.fcmToken
          this._authHttp.get('https://us-central1-coolkids-669fa.cloudfunctions.net/sendGCMNotification?token='+token+'&title='+subject+'&message='+message).subscribe(val=>{
            console.log('sent')
          });
        }

      })

      return firebase.database().ref('user_notifications/'+someoneelse.uid).push({event:event.id,time:time,senderUid:user.uid,senderName:user.full_name,senderThumbnail:user.profile_picture,subject:subject,message:message,kind:kind,link:link,read:false,action:action,answer:answer});
    }

    public callAvatarImage(uid){
         return this._authHttp.get('https://us-central1-coolkids-669fa.cloudfunctions.net/uploadAvatarReload?uid='+uid)

    }
    public likeEventThumbnails(img,eventId,uid){
      let likes=img.likes;
      if (!likes){
        likes={}
      }
      likes['uid']=uid;
      img.likes=likes;
      return firebase.database().ref('eventImages/'+eventId+'/mural/'+img.uid).set(img);

    }
    public banEventThumbnails(img,eventId,uid){
      return firebase.database().ref('eventImages/'+eventId+'/mural/'+img.uid).remove();
    }

    public getEventThumbnails(eventId){
      return firebase.database().ref('eventImages/'+eventId+'/mural/');

    }
    public getChannelReference(channel) : firebase.database.Reference{
      return firebase.database().ref(channel);
    }
    public pushChannel(channel,senderId,data){
      var msg= firebase.database().ref(channel).push({ sender: senderId, message: data });
      msg.remove();
    }


    public getEventQuestions(event){
      return firebase.database().ref('eventQuestions/'+event.id+'/');
    }
    public addEventQuestions(event,message){
      return firebase.database().ref('eventQuestions/'+event.id+'/').push(message);
    }
    public getUserGallery(user){
      return firebase.database().ref('userGallery/'+user.uid+'/');
    }
    public addUserGallery(user,photo){
      return firebase.database().ref('userGallery/'+user.uid+'/').push(photo);
    }


  public getCompanyWrits() {
    return firebase.firestore().collection('company-writs').doc(this._appData.company.dbId).collection('writs');
  }
  public getEventWrits() {
    return firebase.firestore().collection('event-writs').doc('1592880902713').collection('writs');
  }


    public getRooms(){
      return  firebase.firestore().collection('rooms');
    }
    public getAllCompanyNpcs(){
          return firebase.firestore().collection('company-npcs').doc(this._appData.company.dbId).collection('npcs')
    }
    public getAllNpcs(){
      return  firebase.firestore().collection('npcs');
    }
    public updateNpcs(npc){
      return  firebase.firestore().collection('npcs').doc(npc.id).set(npc);
    }

    public addVideoToRoomList(room,video){

      let date=new Date();
      let milis=date.getTime()
      return firebase.firestore().collection('videorooms').doc(room).collection('videos').doc(milis.toString()).set({video:video,date:milis});

    }
    public getVideoToRoomList(room){
      return firebase.firestore().collection('videorooms').doc(room).collection('videos');

    }
    public deleteRoom(room){
      return firebase.firestore().collection('rooms').doc(room.id).delete();
    }
    public updateRoom(room){
            if (!room.localTalks){
              room.localTalks=[]
            }
            if (!room.transparency){
              room.transparency=[]
            }
            if (!room.collisions){
              room.collisions=[]
            }

      if (room.id){
        return firebase.firestore().collection('rooms').doc(room.id).set(room);
      }
      else{
        let date=new Date();
        let milis=date.getTime();
        room.id=milis.toString();
        return firebase.firestore().collection('rooms').doc(room.id).set(room);

      }
    }
    public updateRoomObject(_object){
      if (!_object.space){
        _object.space=this._appData.instagramUser.space;
      }
      var db=firebase.firestore();
//      if (_object.tokenId){
        db.collection('roomObjects').doc(this._appData.room.id.toString()).collection('itens').doc(_object.objectId.toString()).set(_object).then(v=>{
          console.log('success')
        }).catch(err=>{
          console.log(err);
        })
  /*    }
      else{
        db.collection('rooms').doc(this._appData.room.id.toString()).get().then(snapshot => {
          let room=snapshot.data();
          let objects=room.roomObjects;
          let index=0
          let idx=0;
          let found=false;
          if (objects!=null){
            objects.forEach(val=>{
              if (val.objectId==_object.objectId){
                found=true;
                index=idx;
              }
              idx++;
            });
            if (found){
              objects[index]=_object;
            }
            else{
              objects.push(_object);
            }
          }
          else{
            objects=[];
            objects.push(_object);
          }
          room.roomObjects=objects;
          db.collection('rooms').doc(_object.room).set(room);
          })
          .catch(err => {
              console.log('Error getting documents', err);
          });
      }
*/
    }
    public fetchTrelloCards(listId){
      const apiUrlCards = 'https://us-central1-coolkids-669fa.cloudfunctions.net/getListCards?companyId=' +          this._appData.company.dbId + '&listId=' + listId;
      return this._http.get(apiUrlCards);   
    }
    public fetchTrelloListMembers(listId){
      const apiUrlCards = 'https://us-central1-coolkids-669fa.cloudfunctions.net/getMembersOfBoard?companyId=' +          this._appData.company.dbId + '&boardId=' + listId;
      return this._http.get(apiUrlCards);   
    }
    public getNpcDialog(npc){
      return firebase.firestore().collection('npcs').doc(npc);
    }
    public getNPCAIData(npc,uid){
      return firebase.firestore().collection('npcs').doc(npc).collection('users').doc(uid);
    }
    public saveContact(message){
      let date=new Date();
      let milis=date.getTime();
      return firebase.firestore().collection('contact-message').doc(milis.toString()).set(message);

    }
    public getContact(){
      let date=new Date();
      let milis=date.getTime();
      return firebase.firestore().collection('contact-message');

    }

    public getWrits(company){
      if (!company){
        return firebase.firestore().collection('writs');
      }
      else{
          return firebase.firestore().collection('company-writs').doc(company).collection('writs');
      }
    }
    public getUserWrit(user,group){
      return firebase.firestore().collection('user-writs').doc(user.uid).collection('writs').doc(group);
    }
    public getCompanyWrit(user,group){
      return firebase.firestore().collection('company-writ').doc(group).collection('users').doc(user.uid);
    }

    public selectForMailSend(){
      let count=0
      firebase.firestore().collection("users").get().then(val=>{
        val.forEach(v=>{
          let us=v.data();
          if (us.email) {
            if (us.email.length>0){
              if (!us.full_name){ us.full_name=''}
              if (!us.sex){ us.sex='M'}

              firebase.firestore().collection('mailMkt').doc(us.email).set({
                email:us.email,
                lastSend:0,
                name:us.full_name,
                sex:us.sex
              });
              count++;

            }
          }
        });
        console.log(count);
      })
    }
    public removeUnlogged(){
      firebase.firestore().collection('users').where("full_name","==","Usuário deslogado").get().then(val=>{
        val.forEach(v=>{
          let us=v.data();
          firebase.firestore().collection('users').doc(us.uid).delete();
        });
      });

    }
    public getAllUserWrits(user){
      return firebase.firestore().collection('user-writs').doc(user.uid).collection('writs');
    }
    public removeEmail(email){

      return firebase.firestore().collection('remove-email').add({email:email});
    }
    public updateNpcQuestionPoints(npc,room,question){
      let date=new Date();
      let milis=date.getTime();
      return firebase.firestore().collection('user-answers').doc(this._appData.event.id.toString()).collection('users').doc(this._appData.instagramUser.uid).set({
        room: room,
        npc: npc.npcId,
        answer: question.id,
        point:question.point.value,
        attribute:question.point.attribute
      });

    }
    public getTextures(category){
      return firebase.firestore().collection('textures').doc(this._appData.event.id.toString()).collection(category)
    }
    public getCategories(){
      return firebase.firestore().collection('texture-categories').doc(this._appData.event.id.toString())
    }

    public updateTextures(category,url,categories){
      firebase.firestore().collection('textures').doc(this._appData.event.id.toString()).collection(category).add({thumbnail:url})
      categories[category]=category;
      firebase.firestore().collection('texture-categories').doc(this._appData.event.id.toString()).set(categories)

    }
    //CONTAINERs
    public getCompanyContainerRef(){
      return firebase.firestore().collection('company-container').doc(this._appData.company.dbId.toString()).collection('itens')
    }
    public getCompanyTrelloSpecs(companyId){
      return firebase.firestore().collection('company-trello').doc(companyId);
    }
    public getUserContainerRef(){
      return firebase.firestore().collection('user-container').doc(this._appData.instagramUser.uid).collection('itens')
    }
    public getAvatar(){
      let a={
        'child':{
          'body':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2F1592880902713%2Ffemale%2Fbody%2Fbody.png?alt=media&token=b00f294a-25ee-4fdd-ae53-2c0df5d85a03",
          'hair':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2F1592880902713%2Ffemale%2Fhair%2Fhair.png?alt=media&token=873b21aa-64dc-4911-a472-1dd71513176f",
          'chest':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2F1592880902713%2Ffemale%2Fchest%2Fchest1.png?alt=media&token=049c2b94-3d03-4259-90ff-6a1a5c88de7c",
          'leg':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2F1592880902713%2Ffemale%2Flegs%2Flegs.png?alt=media&token=9caf4e12-462a-4c84-8ff2-388dab57785b',
          'shoe':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2F1592880902713%2Ffemale%2Ffeet%2Ffeet.png?alt=media&token=4eab648e-1c67-4f84-8703-4fc65477b15e' ,
          'default':'./assets/characters/k0.png'
        },
        'female':{
          'body':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ffemale%2Fv2%2Fb1.png?alt=media&token=81a9e0f6-1114-4ad7-8a35-cfc1e27640cb",
          'hair1':"",
          'hair2':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ffemale%2Fv2%2Fh1.png?alt=media&token=6c4fa689-db73-4070-8b85-67889ed2a751",
          'hair3':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ffemale%2Fv2%2Fh2.png?alt=media&token=d79504cb-7fa5-4fbc-8163-57c17578d74b",
          'chest1':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ffemale%2Fv2%2Fc1.png?alt=media&token=b6dd5509-799c-49da-b216-e03ae016d4bb",
          'chest2':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ffemale%2Fv2%2Fc2.png?alt=media&token=0a157fae-01d1-4c10-8d0f-74025b525ebc",
          'leg':'',
          'shoe1':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ffemale%2Fv2%2Ff1.png?alt=media&token=dbc91413-3840-4eb5-8ca2-df8b3e3512d9' ,
          'shoe2':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ffemale%2Fv2%2Ff2.png?alt=media&token=aeb7fd17-8b5b-465a-8474-a5620f2888a1' ,
          'shoe3':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Ff3.png?alt=media&token=bc66f8f5-c8ce-493f-8ccc-07eda34b16dd' ,
          'default':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fm0.png?alt=media&token=44dd7a5f-9480-482a-b84b-5ce0e5857f7a'
        },
        'male':{
          'body':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Fb1.png?alt=media&token=8e92d3e7-7159-43e8-bfdf-dac42d2ca1d5",
          'hair1':"",
          'hair2':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Fh1.png?alt=media&token=de19779d-ee98-4a1d-9552-f72d60bb8a58",
          'hair3':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Fh2.png?alt=media&token=8eca0fd3-1535-4c9a-8fb5-6328c6f36642",
          'hair4':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Fh3.png?alt=media&token=c03e18a4-4eaa-43cf-bd18-1a761203daf5",
          'chest1':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Fc1.png?alt=media&token=9eca0d71-898f-409c-94f7-657eeb9bd757",
          'chest2':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Fc2.png?alt=media&token=397b271e-e5b2-49e4-b056-6aa030d538f0",
          'chest3':"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Fc3.png?alt=media&token=15d03fa0-d616-48f7-a9e0-fc66cfc618fb",
          'leg':'',
          'shoe1':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Ff1.png?alt=media&token=b9a7440e-a805-4c67-8739-e81d8bd7ca7a' ,
          'shoe2':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Ff2.png?alt=media&token=ef851d43-b959-41ff-b7e2-d9053016db06' ,
          'shoe3':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fmale%2Fv2%2Fmale-strong%2Ff3.png?alt=media&token=bc66f8f5-c8ce-493f-8ccc-07eda34b16dd' ,
          'default':'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh0.png?alt=media&token=06662e87-0614-40b5-a0d2-9f454977429d'
          }
        }
        //if (this._appData.event && this._appData.event.avatar){
          //a=this._appData.event.avatar;
        //}
      return a;
    }

    public getUserContainer(force){
      if (!this._appData.userEventContainer || force){
        firebase.firestore().collection('user-container').doc(this._appData.instagramUser.uid).collection('itens').where("event","==",this._appData.event.id.toString()).get().then(cdata=>{
          let clist=[];

          cdata.forEach(c=>{
            let item=new ItemBean();
            item.parse(c.data())
            clist.push(item)
          })
          this._appData.userEventContainer=clist
        })
      }
    }
    public removeFromUserContainer(instagramUser,item){
      if (item.quantity==1){
        return firebase.firestore().collection('user-container').doc(instagramUser.uid).collection('itens').doc(item.objectId.toString()).delete();
      }
      else{
        item.quantity=item.quantity-1;
        return firebase.firestore().collection('user-container').doc(instagramUser.uid).collection('itens').doc(item.objectId.toString()).set(item);
      }
    }
    public addToUserContainer(instagramUser,item){
      item.event=instagramUser.event.toString()
      return firebase.firestore().collection('user-container').doc(instagramUser.uid).collection('itens').doc(item.objectId.toString()).set(item)
    }

    public getContainer(id){
      return firebase.firestore().collection('container').doc(id.toString()).collection('itens')
    }
    public removeFromContainer(id,item){
      if (item.quantity==1){
        return firebase.firestore().collection('container').doc(id.toString()).collection('itens').doc(item.objectId.toString()).delete()
      }
      else{
        item.quantity=item.quantity-1;
        return firebase.firestore().collection('container').doc(id.toString()).collection('itens').doc(item.objectId.toString()).set(item)
      }

    }
    public addToContainer(id,item){
      return firebase.firestore().collection('container').doc(id.toString()).collection('itens').doc(item.objectId.toString()).set(item)
    }
    /*
    This reports shows who entered the room during each Day
    Also shows how long each person stayed in the room
    and how many times he logged/dislogged
    */
    public roomUserDailyPresence(room){
      let days={}
      let users={}

      firebase.database().ref('/roomLog/'+room).once("value", (data) =>{
        //each record is a user
        let userCount=0;
        let users=data.val();
        for (let uprop in users) {

          let us=users[uprop]
          let key=uprop
          for (let prop in us) {
            let log=us[prop]
            let milis=log.logoff
            let date=new Date(milis);
            date.setHours(0);
            date.setMilliseconds(0);
            date.setMinutes(0);
            date.setSeconds(0);
            let day=date.getDate()+'-'+date.getMonth()+'-'+date.getFullYear()
            let daymilis=date.getTime();
            if (days[daymilis]){
              let dayData=days[daymilis]
              dayData.duration=dayData.duration+log.duration;
              dayData.logAmount=dayData.logAmount+1;
              dayData.logs.push(log);
              days[daymilis]=dayData;
            }
            else{
              days[daymilis]={date:day,duration:log.duration,logAmount:1,logs:[log]}
            }
          }
          users[uprop]=days;
          days={}
        }
        // do some stuff once
        firebase.database().ref('/roomUserDailyPresence/'+room).set(users)

      });

    }
    public getRoomUserDailyPresence(room){
      return firebase.database().ref('/roomUserDailyPresence/'+room)
    }
    /*
    This reports shows who entered the room during each Day
    Also shows how long each person stayed in the room
    and how many times he logged/dislogged
    */
    public roomReport(room){
      let days={}
      let usersOnDay={}

      firebase.database().ref('/roomLog/'+room).once("value", (data) =>{
        //each record is a user
        let userCount=0;
        let users=data.val();
        for (let uprop in users) {

          let us=users[uprop]
          userCount++;
          let key=uprop
          let newuser=true
          let relogs=0;
          for (let prop in us) {
            let log=us[prop]
            let milis=log.logoff
            let date=new Date(milis);
            let day=date.getDate()+'-'+date.getMonth()+'-'+date.getFullYear()
            if (days[day]){
              let dayData=days[day]
              dayData.average=dayData.average+log.duration
              dayData.relogs=dayData.relogs+1;
              usersOnDay[day][key]=true;
              if (dayData.minimum>log.duration){
                dayData.minimum=log.duration
              }
              if (dayData.maximum<log.duration){
                dayData.maximum=log.duration
              }
              days[day]=dayData;
            }
            else{
              days[day]=[];
              days[day]={average:log.duration,minimum:log.duration,maximum:log.duration,relogs:0}
              usersOnDay[day]={}
              usersOnDay[day][key]=true;
            }

            relogs++;

          }
        }
        for (let day in days){
          let dusers=usersOnDay[day]
          let nusers=Object.keys(dusers).length
          days[day].users=nusers;
          days[day].average=(days[day].average/nusers)
          days[day].relogs=(days[day].relogs/nusers)

        }
        // do some stuff once
        firebase.database().ref('/roomReport/'+room).set(days)

      });

    }
    /*
    This reports shows who entered the room during each Day
    Also shows how long each person stayed in the room
    and how many times he logged/dislogged
    */
    public prepareEventReport(event){
      let days={}
      let usersOnDay={}

      //first see which rooms are of the event
      firebase.firestore().collection('rooms').where('event','==',event.id.toString()).get().then( r=>{
        r.forEach(val=>{
          let room=val.data();
          this.roomReport(room.id)
        })
        Swal({title:'Relatorio de Evento',message:'Salas preparadas'})
      })
    }
    public doEventReport(event){
      let days=[];
      for (let time=event.dateStart;time<event.dateEnd;time=time+24*60*60*1000){//para cada dia....
        let date=new Date(time);
        let day=date.getDate()+'-'+date.getMonth()+'-'+date.getFullYear()
        days.push(day)
      }
      //first see which rooms are of the event
      firebase.firestore().collection('rooms').where('event','==',event.id.toString()).get().then( r=>{
        r.forEach(val=>{
          let room=val.data();
          days.forEach(day=>{
            firebase.database().ref('/roomReport/'+room.id+'/'+day).once("value", (data) =>{
              let report=data.val()
              firebase.database().ref('/eventReport/'+event.id.toString()+'/'+room.id+'/'+day).set(report)
            })
          })
        })
        Swal({title:'Relatorio de Evento',message:'Relatorio concluido'})

      })

    }
    public getAuth(){
      return firebase.auth()
    }
    public getUserRoomItemRef(roomId){
      return firebase.firestore().collection('roomObjects').doc(roomId.toString()).collection('itens')

    }

    public getUsersFromCompany(company){
      ///company-workers/AOOP/workers/FkBuNpN8RIdaoLBRxuIxWWohp872
      return firebase.firestore().collection('company-workers').doc(company.toString()).collection('workers')
    }
    public getUserRoomPosition(roomId){
      return firebase.firestore().collection('userPosition').doc(roomId.toString()).collection('position')

    }
    public getFirebase(){
      return firebase.firestore()
    }


    public test3dUserQuantity(concentration,roomId){
 
      let users=[]
      for(let i=0;i<50;i++){
        let uid='AVATARTESTE'+i.toString();
        users.push(uid)
/*        this.getUserByUid(uid).then(v=>{
          let user=v.data();
          user.avatarUrl=*/
  //        this.updateUserProperty('avatarUrl',['https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/test%2Favatar%2F'+i.toString()+'.glb?alt=media&token=dd7b3657-55fe-4ae4-82d2-e16845892a31'],{uid:uid})          
//        })
      }
      let spaceSpec={columns:1,rows:1,x:40,y:40}
      if (this._appData.room.spaceSpec){
        spaceSpec=this._appData.room.spaceSpec
      }

      let x0=-31
      let x1=-68;
      let y0=-21
      let y1=-57
      let space='1773330971498';
      let date=new Date();
      let time=date.getTime();
      for (let c=0;c<concentration;c++){
              //definindo posicao do usuario
              let x=Math.floor(Math.random() * (x1-x0))+x0;
              let y=Math.floor(Math.random() * (y1-y0))+y0;
              let z=Math.floor(Math.random()*1)
              let space='1773330971498'
              let uid=users[c];
              let o=Math.random()*3.14*2
              let spa=['1773330971498']//space-spaceSpec.columns-1,space-spaceSpec.columns,space-spaceSpec.columns+1,space-1,space,space+1,space+spaceSpec.columns-1,space+spaceSpec.columns,space+spaceSpec.columns+1]
              firebase.firestore().collection('userPosition').doc(roomId.toString()).collection('position').doc(uid.toString()).set({
                  uid:uid.toString(),
                  o:o,
                  s:"",
                  ch:0,
                  a:15,
                  x:x,//Math.floor(Math.random() * (spaces[space].x1 - spaces[space].x0 + 1) + spaces[space].x0),
                  y:y,//Math.floor(Math.random() * (spaces[space].y1 - spaces[space].y0 + 1) + spaces[space].y0),
                  z:z,
                  t:time,
                  spa:spa,//spaces[space].spa,
                  sp:space//space
                })
      }

    }
    public getUserSkills(){
      this.getUserSkillsRef(this._appData.instagramUser).get().then(skData=>{
        let data=skData.data();
        if (data){
          let changed=false;
          //need to make sure old skills are removed and new skills are added.
          this._appData.event.skills.forEach(sk=>{
            let skill={
              name:sk.name,
              id:sk.id,
              thumbnail:sk.thumbnail,
              description:sk.description,
              value:0
            }
            if (!data[sk.id]){
              data[sk.id]=skill
              changed=true;
            }
            this._appData.userEventSkills=data
          })
          if (changed){
            this.getUserSkillsRef(this._appData.instagramUser).set(data);
          }

        }
        else {
        //first time need to create list for this event;
          if (this._appData.event.skills){
            let myskills={}
            let idx=0;
            this._appData.event.skills.forEach(sk=>{
              let skill={
                name:sk.name,
                id:idx,
                thumbnail:sk.thumbnail,
                description:sk.description,
                kind:sk.kind,
                value:0
              }
              myskills[sk.id]=skill;
              idx++;
            })
            this.getUserSkillsRef(this._appData.instagramUser).set(myskills);
            this._appData.userEventSkills=myskills
          }
       };

      })
    }


    public saveNFTMetadata(item) {
      let nft=item.makeNFT()
      firebase.database().ref('nfts/'+item.objectId+'/').set(nft);
    }

    public getLastNPCRequest(npc,user){
      return firebase.firestore().collection('lastUse').doc(npc.id.toString()).collection('users').doc(user.uid)
    }

    public getUserSkillsRef(user){
      return firebase.firestore().collection('userSkills').doc(this._appData.event.id.toString()).collection('users').doc(user.uid)
    }
    public getRecipesRef(event){
      return firebase.firestore().collection('eventRecipes').doc(event.id.toString()).collection('recipes')
    }

    public requestImageAproval(){
      return firebase.firestore().collection('recipeChangeRequest')

    }
    public updateConferenceUsers(room){
      return firebase.firestore().collection('conferenceUsers').doc(room.id)
    }


    public getCalendar(uid){
      return firebase.firestore().collection('userCalendar').doc(uid).collection('calendar')
    }
    public getMapPoints(event,point){
      const southWest=new firebase.firestore.GeoPoint( point.lat-0.01, point.lng+0.01);
      const northEast=new firebase.firestore.GeoPoint( point.lat+0.01, point.lng-0.01);
      return firebase.firestore().collection("maps").doc(event).collection('locations').where(`location`, '>' , southWest )
      .where(`location`, '<' , northEast )
      .get()
    }
    public getMapPointsRef(event){
      const southWest=new firebase.firestore.GeoPoint( -22.97, -43.17);
      const northEast=new firebase.firestore.GeoPoint( -22.96, -43.18);
      return firebase.firestore().collection("maps").doc(event).collection('locations')
    }



    ///WRIT CONTROL
    public getWritReport(){
      return firebase.firestore().collection("writReport");
    }


    ///////////////////FOLDER///////////
    public getItensOnFolder(path){
      return firebase.storage().ref().child(path).getMetadata().then(
        v=>{
          let i=5;
        }
      );
    }
    public getCompanyDresser(company){
      return firebase.firestore().collection('company-dresses').doc(company).collection('itens')
    }

    public getUserPacks(){
      return firebase.firestore().collection('user-packs')
    }

    public moveTrelloCardToList(item,list,dbLocation,action){
      const apiUrlCards = 'https://us-central1-coolkids-669fa.cloudfunctions.net/moveCardsToList'
      let body={
        companyId:this._appData.company.dbId,
        toListId:list,
        cardsToMove:[item.objectId]
      }
      this._http.post(apiUrlCards,body).subscribe(
      (responseCards: any) => {
          if (action=='add'){
            firebase.firestore().collection(dbLocation).doc(this._appData.room.id).collection('itens').doc(item.objectId.toString()).set(item.toDB()).then(v => {})
          }
          else if (action=='remove'){
            firebase.firestore().collection(dbLocation).doc(this._appData.room.id).collection('itens').doc(item.objectId.toString()).delete().then(v => {})
          }
        })


    }

    public sendAvatarUrl(uid,url,avatarId){
      const apiUrlCards = 'https://us-central1-coolkids-669fa.cloudfunctions.net/makeAvatarFromUser'
      let body={
        uid:uid,
        url:url,
        avatarId:avatarId
      }
      this._http.post(apiUrlCards,body).subscribe(
      (responseCards: any) => {
        console.log('avatar sent')
        let json=JSON.parse(responseCards._body)
        this._appData.instagramUser.avatarUrl=json.avatarUrl
        this._appData.instagramUser.avatarId=avatarId
      })
    }
    public getShopifyItens(collection){
      return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/getProductsFromShopify?collection_id='+collection);
    }
    public getShopifyCollections(){
      return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/getCollectionsFromShopify');
    }



    public getMapSession(){
      let requestData = {
        mapType: 'streetview',
        language: 'en-US',
        region: 'US'
      };
      this._http.post('https://tile.googleapis.com/v1/createSession?key=AIzaSyBFdW97agUdFCflpT-X0Dm4gtZYfGpPsgA',requestData).subscribe(v=>{
        let body=v['_body'];
        let bb=JSON.parse(body);
        this._appData.mapSession=bb.session
      })
    }


    public equipReadyPlayer(user,assetId){

      var xmlhttp = new XMLHttpRequest();   // new HttpRequest instance
      var theUrl = 'https://api.readyplayer.me/v1/avatars/'+user.avatarId+'/equip';
      xmlhttp.open("POST", theUrl);
      xmlhttp.setRequestHeader("x-api-key", "sk_live_2AN1C5qbXA6JkZ_i7N67aIhprnXvI0LjSoln");
      xmlhttp.onload = function () {
        if (this.status == 200) {
          //resolve(xmlhttp.response);
        } else {
          /*reject({
            status: this.status,
            statusText: xmlhttp.statusText
          });*/
        }
      };
      xmlhttp.onerror = function () {
/*        reject({
          status: this.status,
          statusText: xmlhttp.statusText
        });*/
      };
      xmlhttp.send(JSON.stringify({data:{assetId:assetId}}));


    }

    public getPanoIds(latitude,longitude){
      let body={
        "locations": [
          {"lat": latitude, "lng": longitude}
        ],
        "radius": 500
      }
      return this._http.post( "https://tile.googleapis.com/v1/streetview/panoIds?session="+this._appData.mapSession+"&key=AIzaSyBFdW97agUdFCflpT-X0Dm4gtZYfGpPsgA",body)

    }

public setCompanyLanding(id,data){
  return firebase.firestore().collection('company-landing').doc(id).set(data);

}
    public getLandingCompany(id) {
    // return this.firestore.collection('company-landing').doc(id);
    return firebase.firestore().collection('company-landing').doc(id)
    }

    public getSocialRoomRef(){
      return firebase.firestore().collection('social-rooms');
    }
    public viewRoom(useri,roomi){
      let userId=useri.uid;
      let roomId=roomi.id.toString()
      let user={
        full_name:useri.full_name,
        uid:useri.uid,
        profile_picture:useri.profile_picture
      }
        firebase.firestore().collection('userRoomView').doc(userId).collection('room').doc(roomId).get().then(v=>{
          if (v.exists){
            let data=v.data();
            data.views=data.views+1;
            firebase.firestore().collection('userRoomView').doc(userId).collection('room').doc(roomId).update({'views':data.views});
            roomi.views=roomi.views+1;
            firebase.firestore().collection('social-rooms').doc(roomId).set(roomi);
          }
          else{
            roomi.views=roomi.views+1;
            firebase.firestore().collection('userRoomView').doc(userId).collection('room').doc(roomId).set({views:1,likes:0,comments:[]});
            firebase.firestore().collection('social-rooms').doc(roomId).set(roomi);
          }
        })
        firebase.firestore().collection('roomView').doc(roomId).collection('user').doc(userId).get().then(v=>{
          if (v.exists){
            let data=v.data();
            data.views=data.views+1;
            firebase.firestore().collection('roomView').doc(roomId).collection('user').doc(userId).update({'views':data.views});
          }
          else{
             firebase.firestore().collection('roomView').doc(roomId).collection('user').doc(userId).set({views:1,likes:0,user:user});
          }
        })


    }
    public likeRoom(useri,roomi){
      let roomId=roomi.id.toString()
      let userId=useri.uid;
      let user={
        full_name:useri.full_name,
        uid:useri.uid,
        profile_picture:useri.profile_picture
      }
        firebase.firestore().collection('userRoomView').doc(userId).collection('room').doc(roomId).get().then(v=>{
          if (v.exists){
            let data=v.data();
            if (!data.likes){
              roomi.likes=roomi.likes+1;
              firebase.firestore().collection('social-rooms').doc(roomId).update({likes:roomi.likes});
            }
            data.likes=data.likes=true;
            firebase.firestore().collection('userRoomView').doc(userId).collection('room').doc(roomId).update({'likes':true});
          }
        })
        firebase.firestore().collection('roomView').doc(roomId).collection('user').doc(userId).get().then(v=>{
          if (v.exists){
            let data=v.data();
            data.likes=data.likes=true;
            firebase.firestore().collection('roomView').doc(roomId).collection('user').doc(userId).update({'likes':true});
          }
        })

    }
    public getRoomCommentsRef(roomId){
      return firebase.firestore().collection('roomComments').doc(roomId).collection('comments');
    }
    public addComment(useri,roomi,comment){
      let roomId=roomi.id.toString()
      let userId=useri.uid;
        firebase.firestore().collection('userRoomView').doc(userId).collection('room').doc(roomId).get().then(v=>{
          if (v.exists){
            let data=v.data();
            let comments=data.comments;
            if (!comments){
              comments=[];
            }
            comments.push(comment);
            firebase.firestore().collection('userRoomView').doc(userId).collection('room').doc(roomId).update({'comments':comments});
          }
        })
        firebase.firestore().collection('roomComments').doc(roomId).collection('comments').doc(comment.time.toString()).set(comment);
    }
      public getVoices(){
        return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/getElevenLabsVoices');
      }
      public getHeyGenVoices(){
        return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/getHeyGenVoices');
      }
      public getHeyGenVideoStatus(taskId){
        return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/getHeyGenVideoStatus?taskId='+taskId);
      }
      public getHeyGenAvatars(){
        return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/getHeyGenAvatars');
      }
      public getRoomIASnapshot(taskId){
            return firebase.firestore().collection('roomIASnapshot').doc(taskId)
      }
        downloadBlob(externalLink,subpath){
          const url = 'https://us-central1-coolkids-669fa.cloudfunctions.net/downloadAndStore';
          let body = {
                        "externalLink":externalLink,
                        "path":"events/1592880902713/rooms/"+this._appData.room.id+"/media/icons/"+subpath,
              
                      }
          return this._authHttp.post(url, JSON.stringify(body));    
        }
      getIconsFromSearch(term,kind,file,args){
        let url='https://us-central1-coolkids-669fa.cloudfunctions.net/getAdminAssets?term='+term+'&kind='+kind
        if (args){
          if (args.voice){
            url=url+'&voice='+args.voice
          }
          if (args.avatar){
            url=url+'&avatar='+args.avatar
          }
          if (args.page){
            url=url+'&page='+args.page
          }
        }
        if (file){
          let headers = new Headers({ 'Content-Type': 'application/json' });
          let options = new RequestOptions({
            headers: headers,
            responseType: ResponseContentType.Blob  // 👈 correct way in Angular 2 Http
          });    
          return this._http.get(url,options);      
        }
        else{
          return this._http.get(url);
        }
      }

  }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/company.service.ts